import { doc, onSnapshot } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import type { AccountStatusSnapshotDTO } from '@src/models/interfaces/accountStatus.interface';

/** Document id of the status copy the backend keeps under each organization. */
export const ACCOUNT_STATUS_DOC_ID = 'current';

class AccountStatusRepository {
  subscribe(
    organizationId: string,
    onChange: (dto: AccountStatusSnapshotDTO | null) => void,
    onError: (error: Error) => void,
  ): () => void {
    const docRef = doc(
      db,
      FSCollections.ORGANIZATIONS,
      organizationId,
      FSCollections.ACCOUNT_STATUS,
      ACCOUNT_STATUS_DOC_ID,
    );

    return onSnapshot(
      docRef,
      snapshot =>
        onChange(snapshot.exists() ? (snapshot.data() as AccountStatusSnapshotDTO) : null),
      onError,
    );
  }
}

export default AccountStatusRepository;
